module.exports = __webpack_public_path__ + "static/massive-panels-fa84d80d80090ad09846cd220a5893ac.jpg";